(function () {
  'use strict';

  if (window.__bnDrawerAnchor) return;
  window.__bnDrawerAnchor = true;

  var HOLD_MS = 1600;
  var anchor = null;
  var until = 0;
  var lastWidth = 0;

  function wrapper() {
    return document.querySelector('.page-wrapper');
  }

  function arm(el) {
    anchor = { el: el, top: el.getBoundingClientRect().top };
    until = Date.now() + HOLD_MS;
  }

  function restore() {
    if (!anchor || Date.now() > until || !anchor.el.isConnected) return;
    var pw = wrapper();
    if (!pw) return;
    var delta = anchor.el.getBoundingClientRect().top - anchor.top;
    if (Math.abs(delta) < 1) return;
    var scroller = pw.scrollHeight > pw.clientHeight + 1 ? pw : document.scrollingElement;
    var before = scroller.style.scrollBehavior;
    scroller.style.scrollBehavior = 'auto';
    scroller.scrollTop += delta;
    scroller.style.scrollBehavior = before;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.isTrusted) return;
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var trigger = target.closest('[aria-haspopup="dialog"]');
      var main = trigger && trigger.closest('#MainContent');
      if (!trigger || !main) return;
      arm(trigger);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target || !anchor || !anchor.el.isConnected) return;
      if (target.closest('.theme-drawer__close-button') || target instanceof HTMLDialogElement) {
        anchor.top = anchor.el.getBoundingClientRect().top;
        until = Date.now() + HOLD_MS;
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape' || !anchor || !anchor.el.isConnected) return;
      anchor.top = anchor.el.getBoundingClientRect().top;
      until = Date.now() + HOLD_MS;
    },
    true
  );

  function watch() {
    var pw = wrapper();
    if (!pw || typeof ResizeObserver === 'undefined') return;
    lastWidth = pw.clientWidth;
    new ResizeObserver(function () {
      var w = pw.clientWidth;
      if (w === lastWidth) return;
      lastWidth = w;
      restore();
    }).observe(pw);
    pw.addEventListener('transitionend', restore);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
